<div class="migrations-container">
  <ziro-breadcrumbs><ziro-breadcrumb-card-item [aboutCardId]="103"></ziro-breadcrumb-card-item></ziro-breadcrumbs>

  @if (isLoading) {
    <ziro-loading-block></ziro-loading-block>
  } @else {
    <div class="d-flex flex-column">
      @if (!isCdrPresent) {
        <div
          class="d-flex mb-3 alert alert-warning text-warning"
          [innerHTML]="'tkey;migrations.cisco.hunt_lists.line_groups.no_cdr.alert' | escapeHtml"
        ></div>
      }
      <div data-automation="hunt-list-details">
        <div class="hunt-list-details">
          <div class="hunt-list-details--wider">
            <div class="hunt-list-details__header">
              {{ 'tkey;migrations.cisco.hunt_lists.line_groups.name' | translate }}
            </div>
            <div class="strong" data-automation="hunt-list-details-name">{{ huntList.name }}</div>
          </div>
          <div>
            <div class="hunt-list-details__header">
              {{ 'tkey;migrations.cisco.hunt_lists.line_groups.description' | translate }}
            </div>
            <div class="strong" data-automation="hunt-list-details-description">{{ huntList.description }}</div>
          </div>
        </div>
        <div class="hunt-list-details">
          <div class="hunt-list-details--wider">
            <div class="hunt-list-details__header">
              {{ 'tkey;migrations.cisco.hunt_lists.line_groups.hunt_pilots' | translate }}
            </div>
            <div data-automation="hunt-list-details-hunt-pilots">
              @for (pilot of huntList.huntPilots; track pilot.huntPilotNumber) {
                <div>
                  <span class="strong me-1">{{ pilot.huntPilotNumber | telephoneNumberFilter }}</span>
                  <span class="hunt-list-details__description">
                    - {{ pilot.description }}
                    @if (isCdrPresent) {
                      (
                      <i class="icon-incoming-calls-small"></i>
                      {{
                        'tkey;migrations.cisco.hunt_lists.line_groups.hunt_pilots.incoming_calls_count'
                          | translate: { cdrCount: pilot.cdrCount }
                      }})
                    }
                  </span>
                </div>
              } @empty {
                <div class="alert alert-warning hunt-list-details__warning">
                  {{ 'tkey;migrations.cisco.hunt_lists.line_groups.hunt_pilots.no_pilot_warning' | translate }}
                </div>
              }
            </div>
          </div>
          <div>
            <div class="hunt-list-details__header">
              {{ 'tkey;migrations.cisco.hunt_lists.line_groups.memberships' | translate }}
            </div>
            <div class="strong" data-automation="hunt-list-details-memberships">
              {{
                'tkey;migrations.cisco.hunt_lists.line_groups.memberships.message'
                  | translate
                    : {
                        members: getNumberOfMembers(huntList.lineGroupMemberships),
                        lineGroups: getNumberOfLineGroups(huntList.lineGroupMemberships),
                      }
              }}
            </div>
          </div>
        </div>
      </div>

      <div>
        @for (lineGroupInfo of lineGroups; track lineGroupInfo.lineGroup.lineGroupName) {
          <ziro-collapsible-card
            [icon]="ZiroIcons.GROUP"
            [label]="lineGroupInfo.cardHeader"
            [shouldBeOpen]="true"
            [dataAutomation]="'migrations-cisco-hunt-lists-line-group-card'"
            [switchId]="'line-group-switch-' + lineGroupInfo.lineGroup.lineGroupName"
            [showChevron]="true"
            [cssClass]="'bg-info text-white fs-5 p-3'"
            [autoScrollOnOpen]="false"
          >
            <div data-automation="hunt-list-line-group-details">
              <div class="hunt-list-details hunt-list-line-group-details__first-row">
                <div>
                  <div class="hunt-list-details__header">
                    {{
                      'tkey;migrations.cisco.hunt_lists.line_groups.line_group_details.distribution_algorithm'
                        | translate
                    }}
                  </div>
                  <span
                    class="strong me-1"
                    [ngbTooltip]="distributionAlgorithmTooltip"
                    [placement]="'top'"
                    [container]="'body'"
                    data-automation="hunt-list-line-group-details-distribution-algorithm"
                  >
                    {{ lineGroupInfo.lineGroup.distributionAlgorithm }}
                    <i [class]="ZiroIcons.TOOLTIP"></i>
                  </span>
                  <ng-template #distributionAlgorithmTooltip>
                    @switch (lineGroupInfo.lineGroup.distributionAlgorithm) {
                      @case ('Broadcast') {
                        <span
                          [innerHTML]="
                            'tkey;migrations.cisco.hunt_lists.line_groups.line_group_details.distribution_algorithm.broadcast.tooltip'
                              | escapeHtml
                          "
                        ></span>
                      }
                      @case ('Circular') {
                        <span
                          [innerHTML]="
                            'tkey;migrations.cisco.hunt_lists.line_groups.line_group_details.distribution_algorithm.circular.tooltip'
                              | escapeHtml
                          "
                        ></span>
                      }
                      @case ('Top Down') {
                        <span
                          [innerHTML]="
                            'tkey;migrations.cisco.hunt_lists.line_groups.line_group_details.distribution_algorithm.top_down.tooltip'
                              | escapeHtml
                          "
                        ></span>
                      }
                      @case ('Longest Idle Time') {
                        <span
                          [innerHTML]="
                            'tkey;migrations.cisco.hunt_lists.line_groups.line_group_details.distribution_algorithm.longest_idle_time.tooltip'
                              | escapeHtml
                          "
                        ></span>
                      }
                    }
                  </ng-template>
                </div>
                <div>
                  <div class="hunt-list-details__header">
                    {{
                      'tkey;migrations.cisco.hunt_lists.line_groups.line_group_details.reversion_timeout' | translate
                    }}
                  </div>
                  <div class="strong" data-automation="hunt-list-line-group-details-reversion-timeout">
                    {{
                      'tkey;migrations.cisco.hunt_lists.line_groups.line_group_details.reversion_timeout.message'
                        | translate: { timeout: lineGroupInfo.lineGroup.rnaReversionTimeout }
                    }}
                  </div>
                </div>
                <div>
                  <div class="hunt-list-details__header">
                    {{ 'tkey;migrations.cisco.hunt_lists.line_groups.line_group_details.log_out' | translate }}
                  </div>
                  <div class="strong" data-automation="hunt-list-line-group-details-log-out">
                    @switch (lineGroupInfo.lineGroup.logoutMembersOnNoAnswer) {
                      @case ('t') {
                        {{ 'tkey;migrations.cisco.hunt_lists.line_groups.line_group_details.log_out.yes' | translate }}
                      }
                      @case ('f') {
                        {{ 'tkey;migrations.cisco.hunt_lists.line_groups.line_group_details.log_out.no' | translate }}
                      }
                      @default {
                        {{
                          'tkey;migrations.cisco.hunt_lists.line_groups.line_group_details.log_out.unknown' | translate
                        }}
                      }
                    }
                  </div>
                </div>
              </div>
              <div class="hunt-list-details__hunt-options">
                <strong>
                  {{ 'tkey;migrations.cisco.hunt_lists.line_groups.line_group_details.hunt_options' | translate }}
                </strong>
              </div>
              <div class="hunt-list-details hunt-list-line-group-details">
                <div>
                  <div class="hunt-list-details__header">
                    {{
                      'tkey;migrations.cisco.hunt_lists.line_groups.line_group_details.hunt_options.no_answer'
                        | translate
                    }}
                  </div>
                  <div class="strong" data-automation="hunt-list-line-group-details-hunt-option-no-answer">
                    {{ lineGroupInfo.lineGroup.huntOptionNoAnswer }}
                  </div>
                </div>
                <div>
                  <div class="hunt-list-details__header">
                    {{
                      'tkey;migrations.cisco.hunt_lists.line_groups.line_group_details.hunt_options.busy' | translate
                    }}
                  </div>
                  <div class="strong" data-automation="hunt-list-line-group-details-hunt-option-busy">
                    {{ lineGroupInfo.lineGroup.huntOptionBusy }}
                  </div>
                </div>
                <div>
                  <div class="hunt-list-details__header">
                    {{
                      'tkey;migrations.cisco.hunt_lists.line_groups.line_group_details.hunt_options.no_agents'
                        | translate
                    }}
                  </div>
                  <div class="strong" data-automation="hunt-list-line-group-details-hunt-option-no-agents">
                    {{ lineGroupInfo.lineGroup.huntOptionNotAvailable }}
                  </div>
                </div>
              </div>
            </div>
            @if (lineGroupInfo.data.length > 0) {
              <ziro-datatable
                [class]="'ziro-card'"
                [columns]="lineGroupColumns"
                [rowDataSource]="lineGroupInfo.data"
                [uniqueRowIdentifier]="'directoryNumber'"
                [dataAutomation]="'migrations-cisco-hunt-lists-line-group-table'"
                [containerCard]="true"
              ></ziro-datatable>
            } @else {
              <div class="alert alert-info" data-automation="hunt-list-line-group-no-members-alert">
                {{ 'tkey;migrations.cisco.hunt_lists.line_groups.table.no_members' | translate }}
              </div>
            }
          </ziro-collapsible-card>
        } @empty {
          <div class="alert alert-info" data-automation="hunt-list-no-line-groups-alert">
            {{ 'tkey;migrations.cisco.hunt_lists.line_groups.no_line_groups_info' | translate }}
          </div>
        }
      </div>
    </div>
  }
</div>
